import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { ArrowLeft, Close } from '@sumup/icons';
import styled from '../../../../styles/styled';
import { IconButton } from '../../../IconButton/IconButton';
import Headline from '../../../Headline';
const headerContainerStyles = ({ theme }) => css `
  position: sticky;
  top: 0;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: ${theme.colors.white};
  z-index: ${theme.zIndex.absolute};

  ${theme.mq.mega} {
    box-shadow: inset ${theme.borderWidth.kilo} 0px 0px ${theme.colors.n300};
  }
`;
const headerContainerStickyStyles = ({ theme, isSticky, }) => isSticky &&
    css `
    box-shadow: inset 0px -${theme.borderWidth.kilo} 0px ${theme.colors.n300};

    ${theme.mq.mega} {
      box-shadow: inset ${theme.borderWidth.kilo} -${theme.borderWidth.kilo} 0px
        ${theme.colors.n300};
    }
  `;
const HeaderContainer = styled.div(headerContainerStyles, headerContainerStickyStyles);
const iconButtonStyles = ({ theme }) => css `
  flex: none;
  margin: ${theme.spacings.bit};
  border-color: transparent !important;
`;
const StyledIconButton = styled(IconButton)(iconButtonStyles);
const headlineStyles = css `
  flex: 1 1 auto;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
`;
const headlineNoBackStyles = ({ theme, noBackButton, }) => noBackButton &&
    css `
    margin-left: ${theme.spacings.zetta};
  `;
const StyledHeadline = styled(Headline)(headlineStyles, headlineNoBackStyles);
export const Header = ({ backButtonLabel, closeButtonLabel, headline, id, isSticky, onBack, onClose, }) => (_jsxs(HeaderContainer, { isSticky: isSticky, children: [onBack && backButtonLabel && (_jsx(StyledIconButton, { type: "button", label: backButtonLabel, onClick: onBack, children: _jsx(ArrowLeft, { size: "24" }, void 0) }, void 0)), _jsx(StyledHeadline, { id: id, size: "four", as: "h2", noMargin: true, noBackButton: !onBack, children: headline }, void 0), closeButtonLabel && (_jsx(StyledIconButton, { type: "button", label: closeButtonLabel, onClick: onClose, children: _jsx(Close, { size: "24" }, void 0) }, void 0))] }, void 0));
